"use client";

import { useState, useEffect } from "react";

export function useCurrency(initialSymbol: string = "$") {
  const [currency, setCurrency] = useState<string>(initialSymbol);

  useEffect(() => {
    const saved = localStorage.getItem("currencySymbol");
    if (saved) setCurrency(saved);
  }, []);

  const updateCurrency = (symbol: string) => {
    setCurrency(symbol);
    localStorage.setItem("currencySymbol", symbol);
  };

  return { currency, updateCurrency };
}
